import deepMerge from "./lib/utils/deepMerge.js";
import { PartialRequired } from "./lib/utils/partialRequired.js";
import { EditorComponent } from "./Components.js";
import { JSONField, Field } from "payload";

type TextEditor = (
  /**
   * Field overrides
   */
  overrides: PartialRequired<JSONField, "name">
) => Field[];

export const TipTapEditor: TextEditor = (overrides) => {
  const editorField = deepMerge<JSONField, Partial<JSONField>>(
    {
      name: "editor",
      type: "json",
      defaultValue: {},
      admin: {
        components: {
          Field: EditorComponent,
        },
      },
    },
    overrides
  );

  const fields = [editorField];

  return fields;
};
